import { useState } from "react";

import axios from "axios";
import "./index.scss"; // Import your CSS file for styling
import CompaniesService from "../../services/companies.service";
const EditCompanyModal = ({ company, onClose, onUpdate }) => {
  const [companyName, setCompanyName] = useState(company.companyName);
  const [newFactures, setNewFactures] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleFileChange = (e) => {
    setNewFactures(Array.from(e.target.files));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      // First update the company name
      if (companyName !== company.companyName) {
        const updatedCompany = await CompaniesService.updateCompany(
          company._id,
          {
            companyName,
          }
        );
        onUpdate(updatedCompany);
      }

      // Then handle file uploads if there are new files
      if (newFactures.length > 0) {
        const formData = new FormData();
        formData.append("companyName", companyName);
        newFactures.forEach((file) => {
          formData.append("facture", file);
        });

        // You'll need to implement this endpoint in your backend
        const response = await axios.patch(
          `${process.env.REACT_APP_API_URL}/companies/${company._id}/add-factures`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        onUpdate(response.data);
      }

      onClose();
    } catch (error) {
      console.error("Error updating company:", error);
      setError("Erreur lors de la mise à jour de l'entreprise");
    } finally {
      setIsLoading(false);
    }
  };

  const handleDeleteFacture = async (fileName) => {
    try {
      await CompaniesService.deleteFacture(company._id, fileName);
      onUpdate({
        ...company,
        facture: company.factures.filter((f) => f !== fileName),
      });
    } catch (error) {
      console.error("Error deleting facture:", error);
      setError("Erreur lors de la suppression de la facture");
    }
  };

  return (
    <div
      className="modal-overlay d-flex align-items-center justify-content-center"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)", // semi-transparent overlay
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        zIndex: 1050,
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          width: "80%",
          maxHeight: "90vh",
          overflowY: "auto",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <div className="modal-content">
          <button className="close-button" onClick={onClose}>
            ×
          </button>
          <h3>Modifier l'entreprise</h3>

          {error && <div className="alert alert-danger">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Nom de l'entreprise</label>
              <input
                type="text"
                className="form-control"
                value={companyName}
                onChange={(e) => setCompanyName(e.target.value)}
                required
              />
            </div>

            <div className="form-group">
              <label>Ajouter de nouvelles factures</label>
              <input
                type="file"
                multiple
                className="form-control"
                onChange={handleFileChange}
              />
            </div>

            <div className="factures-list">
              <h5>Factures existantes:</h5>
              {!company.factures || company.factures.length === 0 ? (
                <p>Aucune facture disponible</p>
              ) : (
                <ul>
                  {company.factures.map((file, index) => (
                    <li key={index}>
                      <div className="file-info mb-2">
                        <a
                          href={`${process.env.REACT_APP_API_URL}/uploads/factures/${file.path}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#3cbbbc",
                            textDecoration: "underline",
                          }}
                        >
                          {file.path}
                        </a>
                        <button
                          type="button"
                          className="btn btn-danger btn-sm ms-2"
                          onClick={() => handleDeleteFacture(file.path)}
                          disabled={isLoading}
                        >
                          Supprimer
                        </button>
                      </div>

                      <div className="d-flex flex-wrap mb-3">
                        <div className="me-3">
                          <label className="form-label">Paiement:</label>
                          <select
                            className="form-select"
                            value={file.paiement}
                            onChange={(e) => {
                              const updatedFactures = [...company.factures];
                              updatedFactures[index].paiement = e.target.value;
                              onUpdate({
                                ...company,
                                factures: updatedFactures,
                              });
                            }}
                          >
                            <option value="non payé">non payé</option>
                            <option value="payé">payé</option>
                          </select>
                        </div>

                        <div>
                          <label className="form-label">Livraison:</label>
                          <select
                            className="form-select"
                            value={file.livraison}
                            onChange={(e) => {
                              const updatedFactures = [...company.factures];
                              updatedFactures[index].livraison = e.target.value;
                              onUpdate({
                                ...company,
                                factures: updatedFactures,
                              });
                            }}
                          >
                            <option value="non livré">non livré</option>
                            <option value="livré">livré</option>
                          </select>
                        </div>
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>

            <div className="modal-actions">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                disabled={isLoading}
              >
                Annuler
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading}
              >
                {isLoading ? "Enregistrement..." : "Enregistrer"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default EditCompanyModal;
